import React, { FC } from 'react';
import { Stack } from '@mui/material';
import CustomDateInput from '../../CustomDateInput';

const DesignStartDates: FC = () => {
  return (
    <>
      <Stack direction={'row'} spacing={2}>
        <CustomDateInput
          label={'labels.CFFDesignStartDate'}
          name={'designStartDate'}
        />
        {/*<CustomDateInput*/}
        {/*<CustomDateInput*/}
        {/*  label={'labels.centralPlanningHubStartDate'}*/}
        {/*  name={'centralPlanningHubStartDate'}*/}
        {/*/>*/}
        {/*</Stack>*/}
        {/*<Stack direction={'row'} pr={2} spacing={2}>*/}
        {/*  <CustomDateInput*/}
        {/*    label={'labels.centresDesignStartDate'}*/}
        {/*    name={'centresDesignStartDate'}*/}
        {/*  />*/}
        <CustomDateInput
          label={'labels.constructionStartDate'}
          name={'constructionStartDate'}
        />
      </Stack>
    </>
  );
};

export default DesignStartDates;
